import styled from 'styled-components';
import { getColor, getSizeBy } from '@invent/wl-ui-kit';

export const MessageWrapper = styled.div`
  display: grid;
  grid-column-gap: ${getSizeBy(3)};
  grid-template-columns: auto 1fr auto;
  align-items: center;
  width: 100%;
  height: 100%;
  padding: ${getSizeBy(3)};
  background-color: ${getColor('surface')};
`;
